import { useState, useEffect } from 'react';
import { hooks as commonHooks } from '@sitebuilder/common';

interface PropsShape {
    column: {
        id: string;
        label: string;
        format?: string;
        disableSorting: boolean;
        columnType?: 'risk' | 'price' | 'rating' | 'documents' | 'twoRow' | 'checklist';
    };
    sortState: { sortProperty: string; isAscending: boolean } | null;
    onToggleSort: (sortProperty: string) => void;
    dataContext: any;
}

export default function TableHeadCell(props: PropsShape) {
    const { column, sortState, dataContext } = props;
    const initialSortClassName = 'fa ';
    const [sortClassName, setSortClassName] = useState<string>(initialSortClassName);
    const [sortLabel, setSortLabel] = useState<string>('widgets_fundList_sort_unsorted');
    let sortProperty = column.id;

    switch (column.columnType) {
        case 'twoRow':
            sortProperty = `${column.id}.item1`;
            break;
        case 'risk':
            sortProperty = `${column.id}.sortOrder`;
            break;
        case 'rating':
            sortProperty = `${column.id}.rating`;
            break;
        default:
            break;
    }

    // Apply classname based on whether column is pinned or not.
    const className = column.id === 'fundName' ? 'col--name' : 'col--collapsible';

    // Compose sort classes and labels
    useEffect(() => {
        if (sortState && sortProperty === sortState?.sortProperty) {
            if (sortState.isAscending) {
                setSortClassName(`${initialSortClassName} fa-sort-up`);
                setSortLabel('widgets_fundList_sort_currentlyAscending');
            } else {
                setSortClassName(`${initialSortClassName} fa-sort-down`);
                setSortLabel('widgets_fundList_sort_currentlyDescending');
            }
        } else {
            setSortClassName(`${initialSortClassName} fa-sort`);
            setSortLabel('widgets_fundList_sort_unsorted');
        }
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [sortState]);

    // Event handlers
    const handleToggleSort = (columnId: string) => {
        props.onToggleSort(sortProperty);
        const label = document?.getElementById(`label-${columnId}`);

        if (label) label.setAttribute('aria-live', sortLabel);
    };

    const i18n = commonHooks.useLocalization();
    const viewLabelTemplate = i18n.format(column.label, dataContext);

    return (
        <th key={column.id} id={`th-${column.id}`} className={`col ${className}`} scope="col">
            {column.disableSorting ? (
                <span className={`head-cell-wrapper`}>{viewLabelTemplate}</span>
            ) : (
                <button
                    className={`head-cell-wrapper ${!column.disableSorting ? 'sort-label' : ''}`}
                    onClick={() => handleToggleSort(column.id)}
                    onKeyPress={(e) => e?.key === 'Enter' && handleToggleSort(column.id)}
                >
                    <span tabIndex={-1}>{viewLabelTemplate}</span>

                    <span id={`label-${column.id}`} className="sr-only">
                        {i18n.t(sortLabel)}
                    </span>

                    <div className="icon-button sort-toggle">
                        <i data-testid="sort-icon" className={sortClassName}></i>
                    </div>
                </button>
            )}
        </th>
    );
}
